import React from 'react';
import ReactDOM from 'react-dom';
import App from './modules/App/App';
import './createShadowRoot';
import '../styles/bootstrap.scss';
import uncapitalizeKeys from './helpers/formatting';

const appRoot = document.getElementById('AppRoot');
const organisationData = uncapitalizeKeys(JSON.parse(appRoot?.getAttribute('data-organisation-data')));

const shadowRoot = document.getElementById('AppRoot').shadowRoot;
const reactRoot = document.createElement('div');
reactRoot.setAttribute('id', 'react-root');
shadowRoot.appendChild(reactRoot);

function init() {
  ReactDOM.render(
    <App organisationData={organisationData} />,
    reactRoot,
  );
}

init();
